import { createApp } from 'vue'
import App from './views/App.vue'
import '@nio-pow/h5-components/dist/style.css'
import 'vant/lib/index.css'
import '@/css/fonts.css'
import Tracker from '@nio-fe/nio-tracker-web'
// import { Env } from '@loca/mfe-utils'
import { getEnv } from '@nio-wad/hooks'
import { NioApmPlus } from '@nio-fe/nio-apm-plus'
require('@nio-fe/horo-h5/dist/style' +
  ((process.config as { [key: string]: any })['mockSwap'] !== 'chargermap' &&
  (process.config as { [key: string]: any })['mockSwap']
    ? '.' + (process.config as { [key: string]: any })['mockSwap']
    : '') +
  '.css')
const mockSwap = (process.config as { [key: string]: any })['mockSwap']
const env = getEnv()
const project =
  mockSwap === 'alps'
    ? env === 'prod'
      ? 'alps'
      : 'alpstest'
    : env === 'prod'
    ? 'nioapp_prod'
    : 'nioapp_test'
Tracker.init(
  { appId: 100119 },
  {
    project,
    show_log: env !== 'prod',
  }
)

const urlParams = new URLSearchParams(window.location.href)
Tracker.track('mockswaph5_visits', {
  refer_page: urlParams.get('from'),
  from_share: Number(urlParams.get('fromShare')) || 0,
})

const app = createApp(App)

app.mount('#app')
